import { render, staticRenderFns } from "./ResourceBox.vue?vue&type=template&id=541d1a7b&scoped=true"
import script from "./ResourceBox.vue?vue&type=script&lang=ts"
export * from "./ResourceBox.vue?vue&type=script&lang=ts"
import style0 from "./ResourceBox.vue?vue&type=style&index=0&id=541d1a7b&prod&scoped=true&lang=less"
import style1 from "./ResourceBox.vue?vue&type=style&index=1&id=541d1a7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541d1a7b",
  null
  
)

export default component.exports